module.exports = __webpack_public_path__ + "pin_pastelblue.a5d423.png";